import React, { Fragment, useState } from "react";
import { Card, CardBody, Col, Input } from "reactstrap";
import { Btn, P } from "../../../../AbstractElements";
import { ClipboardOnTextarea, Copy, Cut, Cutandcopytextarea } from "../../../../Constant";
import HeaderCard from "../../../Common/HeaderCard";
const ClipboardTextarea = () => {
  const vall = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has";
  const [clipBoardOnTextAreaValue, setClipBoardOnTextAreaValue] = useState(vall);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(clipBoardOnTextAreaValue);
    setClipBoardOnTextAreaValue(clipBoardOnTextAreaValue);
  };

  const handleCut = async () => {
    await navigator.clipboard.writeText(clipBoardOnTextAreaValue);
    setClipBoardOnTextAreaValue("");
  };
  return (
    <Fragment>
      <Col sm="12" md="6">
        <Card>
          <HeaderCard title={ClipboardOnTextarea} />
          <CardBody>
            <div className="clipboaard-container">
              <P className="card-description">{Cutandcopytextarea}</P>
              <Input className="form-control" id="clipboardExample2" type="textarea" rows="1" spellCheck="false" value={clipBoardOnTextAreaValue} onChange={({ target: { value } }) => setClipBoardOnTextAreaValue(value)}></Input>
              <div className="mt-3 text-end">
                <Btn color="primary btn-clipboard me-1" onClick={handleCopy}>
                  <i className="fa fa-copy"></i> {Copy}
                </Btn>
                <Btn color="secondary btn-clipboard-cut" onClick={handleCut}>
                  <i className="fa fa-cut"></i> {Cut}
                </Btn>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};
export default ClipboardTextarea;
